export * from './getLang'
